import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { useAuthStore } from './store/authStore';

// Layout
import { Layout } from './components/Layout/Layout';

// Onboarding - DISABLED
// import { OnboardingTour } from './components/Onboarding/OnboardingTour';

// Pages
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import { NotFound } from './pages/NotFound';

// Vehicles
import { VehicleList } from './pages/Vehicles/VehicleList';
import { VehicleForm } from './pages/Vehicles/VehicleForm';

// Suppliers
import { SupplierList } from './pages/Suppliers/SupplierList';
import { SupplierForm } from './pages/Suppliers/SupplierForm';

// Customers
import { CustomerList } from './pages/Customers/CustomerList';
import { CustomerForm } from './pages/Customers/CustomerForm';

// Drivers
import { DriverList } from './pages/Drivers/DriverList';
import { DriverForm } from './pages/Drivers/DriverForm';

// Users
import UserListPage from './pages/Users/UserListPage';

// Items
import { ItemList } from './pages/Items/ItemList';
import { ItemForm } from './pages/Items/ItemForm';

// Trips
import { TripList } from './pages/Trips/TripList';
import { TripForm } from './pages/Trips/TripForm';
import { TripDetail } from './pages/Trips/TripDetail';

// Expenses
import { ExpenseList } from './pages/Expenses/ExpenseList';
import { ExpenseForm } from './pages/Expenses/ExpenseForm';

// Reports
import { ReportMenu } from './pages/Reports/ReportMenu';
import { VehicleProfitability } from './pages/Reports/VehicleProfitability';
import { DebtStatus } from './pages/Reports/DebtStatus';
import { FuelEfficiency } from './pages/Reports/FuelEfficiency';

// Salaries
import { SalaryCalculation } from './pages/Salaries/SalaryCalculation';

// Debt
import { DebtList } from './pages/Debt/DebtList';
import { DebtDetail } from './pages/Debt/DebtDetail';

// Warehouses
import { WarehouseList } from './pages/Warehouses/WarehouseList';
import { WarehouseForm } from './pages/Warehouses/WarehouseForm';
import { WarehouseDetail } from './pages/Warehouses/WarehouseDetail';
import { ManualReceiptPage } from './pages/Warehouses/ManualReceiptPage';
import { ManualIssuePage } from './pages/Warehouses/ManualIssuePage';
import AuditLogPage from './pages/Warehouses/AuditLogPage';
import { StockAlertPage } from './pages/Warehouses/StockAlertPage';
import PeriodLockPage from './pages/Warehouses/PeriodLockPage';

function App() {
  const { checkAuth, isAuthenticated } = useAuthStore();

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  return (
    <BrowserRouter>
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 3000,
          style: {
            background: '#333',
            color: '#fff',
          },
        }}
      />
      {/* <OnboardingTour /> - DISABLED */}

      <Routes>
        {/* Public routes */}
        <Route
          path="/login"
          element={
            isAuthenticated ? <Navigate to="/dashboard" replace /> : <Login />
          }
        />

        {/* Protected routes */}
        <Route element={<Layout />}>
          <Route path="/dashboard" element={<Dashboard />} />

          {/* Vehicles */}
          <Route path="/vehicles" element={<VehicleList />} />
          <Route path="/vehicles/new" element={<VehicleForm />} />
          <Route path="/vehicles/:id/edit" element={<VehicleForm />} />

          {/* Suppliers */}
          <Route path="/suppliers" element={<SupplierList />} />
          <Route path="/suppliers/new" element={<SupplierForm />} />
          <Route path="/suppliers/:id/edit" element={<SupplierForm />} />

          {/* Customers */}
          <Route path="/customers" element={<CustomerList />} />
          <Route path="/customers/new" element={<CustomerForm />} />
          <Route path="/customers/:id/edit" element={<CustomerForm />} />

          {/* Drivers */}
          <Route path="/drivers" element={<DriverList />} />
          <Route path="/drivers/new" element={<DriverForm />} />
          <Route path="/drivers/:id/edit" element={<DriverForm />} />

          {/* Users */}
          <Route path="/users" element={<UserListPage />} />

          {/* Items */}
          <Route path="/items" element={<ItemList />} />
          <Route path="/items/new" element={<ItemForm />} />
          <Route path="/items/:id/edit" element={<ItemForm />} />

          {/* Trips */}
          <Route path="/trips" element={<TripList />} />
          <Route path="/trips/new" element={<TripForm />} />
          <Route path="/trips/:id" element={<TripDetail />} />
          <Route path="/trips/:id/edit" element={<TripForm />} />

          {/* Expenses */}
          <Route path="/expenses" element={<ExpenseList />} />
          <Route path="/expenses/new" element={<ExpenseForm />} />
          <Route path="/expenses/:id/edit" element={<ExpenseForm />} />

          {/* Reports */}
          <Route path="/reports" element={<ReportMenu />} />
          <Route path="/reports/vehicle-profitability" element={<VehicleProfitability />} />
          <Route path="/reports/debt-status" element={<DebtStatus />} />
          <Route path="/reports/fuel-efficiency" element={<FuelEfficiency />} />

          {/* Salaries */}
          <Route path="/salaries" element={<SalaryCalculation />} />

          {/* Debt */}
          <Route path="/debt" element={<DebtList />} />
          <Route path="/debt/suppliers/:id" element={<DebtDetail />} />
          <Route path="/debt/customers/:id" element={<DebtDetail />} />

          {/* Warehouses */}
          <Route path="/warehouses" element={<WarehouseList />} />
          <Route path="/warehouses/new" element={<WarehouseForm />} />
          <Route path="/warehouses/manual-receipt" element={<ManualReceiptPage />} />
          <Route path="/warehouses/manual-issue" element={<ManualIssuePage />} />
          <Route path="/warehouses/stock-alerts" element={<StockAlertPage />} />
          <Route path="/warehouses/period-locks" element={<PeriodLockPage />} />
          <Route path="/warehouses/audit-logs" element={<AuditLogPage />} />
          <Route path="/warehouses/:id" element={<WarehouseDetail />} />
          <Route path="/warehouses/:id/edit" element={<WarehouseForm />} />
        </Route>

        {/* Redirects */}
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
